export default __webpack_public_path__ + "static/media/open-folder.2962922c.svg";